import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UiService } from '../../core/services/core.ui.service';
import { StateService } from '@uirouter/angular';
import { forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'project-search',
  template: require('./project-search.component.html')
})
export class ProjectSearchComponent implements OnInit {
  selection: any = null;
  search: any = { q: '', s: 'project', c: '', page_num: 1, page_size: 20 };
  results: any[] = [];
  selected: any[] = [];
  loading: any;
  categories: any;
  searchable: any;

  constructor(
    private http: HttpClient,
    private uiService: UiService,
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    this.search = { q: '', s: 'project', c: '', page_num: 1, page_size: 20 };
    this.results = [];


    this.http.get('/api/trove')
    .subscribe((data: any) => {
            var items = data.items;
            var cat = _.find(items, function (item) {
                return item.id == 0;
            })
            items = _.filter(items, function (item) {
                return item.id > 0;
            });

            this.selected = [];

            this.setChildren(cat, items);
            this.categories = this.flatten(cat, 0);
        }
    );
  }

  nextPage() {
    this.search.page_num += 1;
    this.doSearch();
  }

  previousPage() {
    this.search.page_num -= 1;
    this.doSearch();
  }

  setPage(size: number) {
    this.search.page_size = size;
    this.doSearch(true);
  }

  options = { preventSelect: true, style: "{'padding-left':depth+'em'}" };

  onSelectCallback(item: any) {
    if (item) {
      const duplicate = this.selected.find((i) => i.id == item.id);
      if (!duplicate) {
        this.selected.push(item);
      }
      item = undefined;
    }
  }

  remove(item: any) {
    this.selected = this.selected.filter((i) => i.id != item.id);
  }

  doSearch(resetPaging?: boolean) {
    if (resetPaging) {
      this.search.page_num = 1;
    }
    if (this.loading) {
      this.loading.unsubscribe();
      this.loading = false;
    }

    this.loading = this.http
      .get('/api/search/', { params: this.search })
      .pipe(
        catchError((error) => {
          this.uiService.message.showWarning(
            'Sorry, could not fetch the search results',
            'Search Failed'
          );
          return [];
        })
      )
      .subscribe((response: any) => {
        this.loading = false;
        this.results = response.items
          ? response.items
              .map((item) => ({
                ...item,
                searchable: this.searchable + ' ' + item.categoryName,
              }))
              .reverse()
          : [];
      });
  }

  setChildren(item: any, items: any[]) {
    item.children = [];
    items.forEach((i) => {
      if (i.parentCategoryId == item.id) {
        this.setChildren(i, items);
        item.children.push(i);
      }
    });
  }

  flatten(item: any, depth: number): any[] {
    let ret: any[] = [];
    item.children.forEach((i) => {
      i.searchable = item.searchable + ' ' + i.categoryName;
      const itm = { ...i, depth: depth, label: i.categoryName };
      delete itm.children;
      ret.push(itm);
      ret = ret.concat(this.flatten(i, depth + 1));
    });
    return ret;
  }

  goTo(stateName, params) {
    this.stateService.go(stateName, params);
  }
}
